// extracted by mini-css-extract-plugin
export default {"textBlock":"PrivacyPolicy_textBlock__MYQ2v","article":"PrivacyPolicy_article__9IPXm"};